module.exports = __webpack_public_path__ + "static/media/pg-parceria.55387889.png";